import React, { useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import {
  isAndroid,
  isIOS,
  isMacOs,
  isWindows,
} from "react-device-detect";

const DownloadBiosynciqApp = () => {
  useEffect(() => {
    // const storeLink =
    //   isAndroid || isWindows
    //     ? "https://play.google.com/store/apps/details?id=com.innovo"
    //     : "https://apps.apple.com/us/app/innovo/id6587574641";

    // window.location.href = storeLink;
  }, []);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          fontWeight={600}
          color="text.secondary"
        >
          Coming Soon
        </Typography>
      </Box>
    </Container>
  );
};

export default DownloadBiosynciqApp;